import { gql } from '@apollo/client';

/**
 * 单任务轮询，供提交后的等待弹窗使用。
 *
 * 任务不存在或跨渠道时后端返回 null（两者刻意不可区分），调用方需按 null 处理而不是假定必有值。
 */
export const GET_PORTAL_ORDER_EXPORT_TASK = gql`
    query GetPortalOrderExportTask($taskId: ID!) {
        portalOrderExportTask(taskId: $taskId) {
            taskId
            status
            exportMode
            operatorAccount
            requestedCount
            totalCount
            fileName
            fileSize
            submittedAt
            completedAt
        }
    }
`;

/* 导出记录列表；渠道级可见（含同渠道他人提交的），page 0-based，按 id DESC 排序 */
export const GET_PORTAL_ORDER_EXPORT_TASKS = gql`
    query GetPortalOrderExportTasks($page: Int, $size: Int) {
        portalOrderExportTasks(page: $page, size: $size) {
            content {
                taskId
                status
                exportMode
                operatorAccount
                requestedCount
                totalCount
                fileName
                fileSize
                submittedAt
                completedAt
            }
            totalElements
            totalPages
            page
            size
        }
    }
`;

/*
 * 下载链接按需签发、不落库，过期后再查一次即得新 URL。
 * 失败走 success=false + errorCode（五种），不抛 GraphQL 错误，故调用方必须自行分支提示。
 */
export const GET_PORTAL_ORDER_EXPORT_DOWNLOAD_URL = gql`
    query GetPortalOrderExportDownloadUrl($taskId: ID!) {
        portalOrderExportDownloadUrl(taskId: $taskId) {
            success
            url
            errorCode
            messageKey
        }
    }
`;
